import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { IPriceRuleViewModel } from "../interface/IPriceRule";
import { GetAddressParamModel } from "../model/address";
import AddressService from "../service/AddressService";

import { RootState } from "../store/store";

import { logoutUser } from "./common";


export const resetAddressPriceRule= createAction("addresspricerule/reset")

const _service = new AddressService();

export const getAddressPriceRuleAsync = createAsyncThunk(
  "addresspricerule/pricerules",
  async (params:GetAddressParamModel) => {
    const response = await _service.getAddressPriceRulesService(params);
    return response;
  }
);

type SliceState = { value: IPriceRuleViewModel[]|null ,status:string,apiCallCount:number } 
const initialState = {
  value: null,
  status: COMMON_STATUS.INITIAL,
  apiCallCount:0
} as SliceState;

export const addressPriceRuleSlice = createSlice({
  name: "addresspricerule",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAddressPriceRuleAsync.pending, (state:SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getAddressPriceRuleAsync.fulfilled, (state:SliceState, action) => {

        state.value = action.payload;
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getAddressPriceRuleAsync.rejected, (state:SliceState, ) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetAddressPriceRule, (n) => {
        return initialState;
      });
  },
});


export const getAddressPriceRule = (state:RootState) => state.addresspricerule.value && state.addresspricerule.value.length>0?state.addresspricerule.value.filter(i=> i.itemId===1):null;
export default addressPriceRuleSlice.reducer;